import React, { Fragment } from 'react'

import { AssignTree } from 'src/types'
import { PropsTreeSelected } from 'src/views/Management/Administration/views/tree'

import { Nodes } from '../Nodes'

type Props = {
  nodes: AssignTree[]
  isChild?: boolean
  addNode: (node: AssignTree) => void
  setTreeSelected?: (treeSelected: PropsTreeSelected) => void
}

export function RenderNodes({
  addNode,
  isChild,
  nodes,
  setTreeSelected
}: Props) {
  return (
    <>
      {nodes.map(node => (
        <Fragment key={node.assign_tree_id}>
          <Nodes
            addNode={addNode}
            data={node}
            isChild={isChild}
            key={node.assign_tree_id}
            setTreeSelected={setTreeSelected}
            type={node.p_assign_tree_type}
          />
          {node.childrens && (
            <div
              style={{
                marginLeft: isChild ? '10%' : '5%',
                position: 'relative'
              }}
            >
              <RenderNodes
                addNode={addNode}
                nodes={node.childrens}
                isChild
                setTreeSelected={setTreeSelected}
              />
            </div>
          )}
        </Fragment>
      ))}
    </>
  )
}
